export const CALL_STATUS = {
  COMPLETED: "completed",
  NO_ANSWER: "no-answer",
  VOICEMAIL: "voicemail",
  BUSY: "busy",
  FAILED: "failed",
  REJECTED: "rejected",
} as const;

export type CallStatus = (typeof CALL_STATUS)[keyof typeof CALL_STATUS];

const CALL_STATUS_LABELS: Record<CallStatus, string> = {
  [CALL_STATUS.COMPLETED]: "Completed",
  [CALL_STATUS.NO_ANSWER]: "No answer",
  [CALL_STATUS.VOICEMAIL]: "Voicemail",
  [CALL_STATUS.BUSY]: "Busy",
  [CALL_STATUS.FAILED]: "Failed",
  [CALL_STATUS.REJECTED]: "Rejected",
};

export const getCallStatusLabel = (
  status: string | null | undefined
): string => {
  if (!status) return "-";
  const key = status as CallStatus;
  return CALL_STATUS_LABELS[key] ?? status;
};

